import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  Typography,
} from "@mui/material";

const MMTCUserDetailsTable = ({ data }) => {
  const {
    fullName,
    mobileNumber,
    emailAddress,
    dob,
    customerRefNo,
    dgCustomerRefNo,
    kycStatus,
    isCorporate,
    partner_id,
    billingAddress,
    deliveryAddress,
    kycInfo,
  } = data;

  // -------- BASIC DETAILS --------
  const basicRows = [
    { label: "Full Name", value: fullName },
    { label: "Mobile", value: mobileNumber },
    { label: "Email", value: emailAddress },
    { label: "DOB", value: new Date(dob).toLocaleDateString() },
    { label: "Customer Ref No", value: customerRefNo },
    { label: "DG Customer Ref No", value: dgCustomerRefNo },
    { label: "Partner ID", value: partner_id },
    { label: "Corporate Account", value: isCorporate === "Y" ? "Yes" : "No" },
    { label: "KYC Status", value: kycStatus === "Y" ? "Verified" : "Pending" },
  ];

  // -------- KYC INFO --------
  const kycRows = [
    { label: "Name Proof Type", value: kycInfo?.nameProofType },
    { label: "Name Proof Doc No", value: kycInfo?.nameProofDocNo },
    { label: "Address Proof Type", value: kycInfo?.addressProofType || "N/A" },
    { label: "Address Proof Doc No", value: kycInfo?.addressProofDocNo || "N/A" },
  ];

  // -------- BILLING ADDRESS (First One) --------
  const billing = billingAddress?.[0];

  const billingRows = billing
    ? [ 
         { label: "Billing ID", value: billing.id },
        { label: "Line 1", value: billing.line1 },
        { label: "Line 2", value: billing.line2 },
        { label: "City", value: billing.city },
        { label: "State", value: billing.state },
        { label: "Country", value: billing.country },
        { label: "Zip", value: billing.zip },
        { label: "Mobile", value: billing.mobileNumber },
      ]
    : [];

  const renderRows = (rows) =>
    rows.map((row, idx) => (
      <TableRow key={idx}>
        <TableCell sx={{ fontWeight: 600 }}>{row.label}</TableCell>
        <TableCell>{row.value || "N/A"}</TableCell>
      </TableRow>
    ));

  return (
    <TableContainer component={Paper} sx={{ mt: 3 }}>
      <Typography variant="h6" sx={{ p: 2, color: "primary.main" }}>
        Basic Details
      </Typography>
      <Table>
        <TableBody>{renderRows(basicRows)}</TableBody>
      </Table>

      <Typography variant="h6" sx={{ p: 2, color: "primary.main" }}>
        KYC Information
      </Typography>
      <Table>
        <TableBody>{renderRows(kycRows)}</TableBody>
      </Table>

      <Typography variant="h6" sx={{ p: 2, color: "primary.main" }}>
        Billing Address
      </Typography>
      <Table>
        <TableBody>{renderRows(billingRows)}</TableBody>
      </Table>
    </TableContainer>
  );
};

export default MMTCUserDetailsTable;
